import React, { useContext } from 'react';
import * as Styled from './Emboss.styled';
import { ContainerQueryContext } from '../../util/ContainerQuery.context';
/**
 * Emboss is used to wrap a component that when hovered causes the contents to appear embossed on the page.
 */
var Emboss = function (_a) {
    var _b = _a.forceEmbossShadow, forceEmbossShadow = _b === void 0 ? false : _b, children = _a.children, className = _a.className;
    var styleQueryMode = useContext(ContainerQueryContext).styleQueryMode;
    return (React.createElement(Styled.Emboss, { className: className, "$forceEmbossShadow": forceEmbossShadow, "$styleQueryMode": styleQueryMode },
        React.createElement(Styled.Contents, null, children)));
};
export default Emboss;
